var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OrderList"},[_c('GlobalInfoBar',{attrs:{"title":"差价订单","content":"查看或处理门店的差异订单，与小程序差价订单同步"}}),_c('GlobalChunk',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('OrderFrom')],1),_c('div',{staticClass:"caseOrder"},[_c('OrderTable')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }